import { cartActionTypes, cartItemActionTypes } from '../app/enums';
import { Cart, CartContextType, CartItem, defaultCartContext, VehicleInfo } from '../models/cart.interface';
import { Carts } from '../api/api';
import { SearchType } from '../models/search.interface';

export type CartAction =
  | { type: cartActionTypes.ADD_ITEM; item: CartItem }
  | { type: cartActionTypes.RESET_CART; locationId?: string }
  | { type: cartActionTypes.CHECKOUT_CART }
  | { type: cartActionTypes.TOGGLE_CART }
  | { type: cartActionTypes.LOAD_CART; cart: Cart }
  | { type: cartActionTypes.UPDATE_CART_ITEM; item: CartItem; action: cartItemActionTypes; search?: SearchType}
  | { type: 'field'; fieldName: string; payload: any };

const addItemToCart = (cartItem: CartItem, cart: CartContextType) => {
  const cartItems = cart.cartItems
  const itemCount = cartItem.quantity
  
  const updatedItemIndex = cartItems.findIndex(
    item => item.searchId === cartItem.searchId
  );
    
  if(updatedItemIndex < 0) {
    cartItems.push({ ...cartItem, quantity: itemCount}); 
  } else {
    const updatedItem = {
      ...cartItems[updatedItemIndex]
    };
    updatedItem.quantity = updatedItem.quantity + itemCount;
    cartItems[updatedItemIndex] = updatedItem;
  }

  cart.itemCount = cart.itemCount + itemCount

  let totalAmount=0;
  cartItems.forEach(function (cItem) {
    totalAmount = totalAmount + (cItem.quantity * cItem.price)
  });

  cart.totalAmount = totalAmount
  cart.isCartDrawerOpen = true
  cart.cartItems = cartItems

  return {
    ...cart,
    isCartDrawerOpen: true
  };
}

const toggleCart = (state: CartContextType) => {
  if(state.isCartDrawerOpen){
    return {
      ...state,
      isCartDrawerOpen: false
    }
  } else {
    return {
      ...state,
      isCartDrawerOpen: true
    }
  }
}

const incrementCartItem = (cartItem: CartItem, cart: CartContextType) => {
  const cartItems = cart.cartItems
  const updatedItemIndex = cartItems.findIndex(
    item => item.cartItemId === cartItem.cartItemId
  );

  const updatedItem = {
    ...cartItems[updatedItemIndex]
  };

  updatedItem.quantity++;
  cartItems[updatedItemIndex] = updatedItem;

  const itemCount = cart.itemCount + 1
  const totalAmount = cart.totalAmount + cartItem.price

  return {
    ...cart,
    cartItems,
    itemCount: itemCount,
    totalAmount: totalAmount
  }
}

const decrementCartItem = (cartItem: CartItem, cart: CartContextType) => {
  const cartItems = cart.cartItems

  const updatedItemIndex = cartItems.findIndex(
    item => item.cartId === cartItem.cartId
  );

  const updatedItem = {
    ...cartItems[updatedItemIndex]
  };

  const itemCount = cart.itemCount - 1
  const totalAmount = cart.totalAmount - cartItem.price
  
  if(updatedItem.quantity === 1){
    if(updatedItemIndex > -1){
      cartItems.splice(updatedItemIndex, 1)
    }
  }else{
    updatedItem.quantity--;
    cartItems[updatedItemIndex] = updatedItem;
  }

  return {
    ...cart,
    cartItems,
    itemCount: itemCount,
    totalAmount: totalAmount
  }
}

const updateField = (state: CartContextType, fieldName: string, payload: any) => {
  return {
    ...state,
    [fieldName]: payload,
  }
}

const loadCart = (state: CartContextType, cart: Cart) => {
  let cartItems: CartItem[] = []
  let itemCount: number = 0;
  let totalAmount: number = 0;

  if(cart.items !== undefined && cart.items.length > 0){
    cart.items.forEach((item) => {
      let cartItem: CartItem = {
        cartId: item.cartId,
        cartItemId: item.id,
        searchId: item.searchId,
        keyType: item.keyType,
        price: item.price,
        quantity: item.quantity,
        lotNumber: item.lotNumber,
        sellerName: item.sellerName
      }
  
      itemCount = itemCount + item.quantity
      totalAmount = totalAmount + (item.price * item.quantity)
      cartItems.push(cartItem)
    })
  }

  return {
    ...state,
    cartId: cart.id,
    locationId: cart.locationId,
    cartItems: cartItems,
    itemCount: itemCount,
    totalAmount: totalAmount
  }
}

const updateCartItem = (
  cartItem: CartItem, 
  cart: CartContextType, 
  action: cartItemActionTypes, 
  search?: SearchType) => 
{
  switch(action){
    case cartItemActionTypes.ADD_ITEM_QUANTITY: { 
      return incrementCartItem(cartItem, cart);
    }
    case cartItemActionTypes.SUBTRACT_ITEM_QUANTITY: { 
      return decrementCartItem(cartItem, cart);
    }
    case cartItemActionTypes.UPDATE_CART_ITEM_VEHICLE: {
      return updateCartItemVehicle(cartItem, cart, search)
    }
    default:
      return cart
  }
}

const updateCartItemVehicle = (cartItem: CartItem, cart: CartContextType, search?: SearchType) => {
  const cartItems = cart.cartItems

  const updatedItemIndex = cartItems.findIndex(
    item => item.cartItemId === cartItem.cartItemId
  );

  const updatedItem = {
    ...cartItems[updatedItemIndex]
  };

  if(search !== undefined){
    const vehicleInfo: VehicleInfo = {
      year: search.year,
      make: search.make,
      model: search.model,
      vin: search.vin
    }

    updatedItem.vehicleInfo = vehicleInfo
  }

  cartItems[updatedItemIndex] = updatedItem
  return {
    ...cart,
    cartItems
  }
}

const resetCart = (state:CartContextType, locationId?: string) => {
  if(locationId){
    Carts.getSelfCarts(locationId)
    .then((carts) => {
      console.log(carts)
      return loadCart(state, carts[0])
    })
    .catch((error) => { 
      return defaultCartContext
    }) 
  }

  return defaultCartContext;
}

export const cartReducer = (state: CartContextType, action:CartAction) => {
  switch (action.type){
    case 'field': 
      return updateField(state, action.fieldName, action.payload);  
    case cartActionTypes.ADD_ITEM: {
      return addItemToCart(action.item, state);
    }
    case cartActionTypes.UPDATE_CART_ITEM: {
      return updateCartItem(action.item, state, action.action, action.search);
    }
    case cartActionTypes.RESET_CART: {
      return resetCart(state, action.locationId)
    } 
    case cartActionTypes.TOGGLE_CART: {
      return toggleCart(state);
    }   
    case cartActionTypes.LOAD_CART: {
      return loadCart(state, action.cart);
    }   
    default:
      return state;
  }
}


  